import React from "react";
import { Grid, TextField, Paper, MenuItem, Typography } from "@mui/material";

export default function UserDetailsForm({ formData, setFormData }) {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        maxWidth: 500,
        mx: "auto",
        mt: 5,
        borderRadius: 3,
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          mb: 3,
          color: "#333",
        }}
      >
        User Details
      </Typography>

      <Grid container spacing={3}>
        {/* Username - Readonly */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Username"
            value={formData.username}
            variant="outlined"
            InputProps={{ readOnly: true }}
            sx={{ backgroundColor: "#f4f4f4", borderRadius: 1 }}
          />
        </Grid>

        {/* Role Selection */}
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            label="Role"
            value={formData.role}
            onChange={(e) => setFormData({ ...formData, role: e.target.value })}
            variant="outlined"
          >
            {["user", "premium"].map((role) => (
              <MenuItem key={role} value={role}>
                {role.charAt(0).toUpperCase() + role.slice(1)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Amount Paid */}
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            label="Amount Paid"
            type="number"
            value={formData.amount}
            onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
            variant="outlined"
          />
        </Grid>

        {/* Order Date */}
        <Grid item xs={12} sm={6}>
          <TextField
            required
            fullWidth
            type="date"
            label="Order Date"
            value={formData.orderDate}
            onChange={(e) => setFormData({ ...formData, orderDate: e.target.value })}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
          />
          
        </Grid>
         {/* Exhibitors Count */}
                  <Grid item xs={6}>
                    <TextField
                      required
                      fullWidth
                      label="Exhibitors Count"
                      type="number"
                      value={formData.exhibitors_count}
                      onChange={(e) => setFormData({ ...formData, exhibitors_count: e.target.value })}
                      variant="outlined"
                    />
                  </Grid>
      </Grid>
    </Paper>
  );
}
